import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../constants/path';
import { scrollToAnchor } from '../../utils';
import { HeadComponent } from '../HeadComponent';
import { withTemplate } from '../template/withTemplate';
import { PrimaryTemplate } from '../template/PrimaryTemplate';
import { convertHtmlToReactDomWithParams } from '../../utils/htmlUtils';
import LocalizedBreadcrumbItem from '../breadcrumb/LocalizedBreadcrumbsItem';

import './LegalNoticePage.scss';

class LegalNoticePage extends React.Component {
    componentDidMount() {
        scrollToAnchor(this.props.location);
    }

    componentDidUpdate() {
        scrollToAnchor(this.props.location);
    }

    render() {
        const { i18n } = this.props;
        return (
            <main className="conteneur conteneur-mobile" id="p-mentionslegales">
                <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />
                <LocalizedBreadcrumbItem to={PATH.LEGAL_NOTICE_PATH}>
                    {i18n.BREADCRUMB}
                </LocalizedBreadcrumbItem>
                <h1>{i18n.TITLE}</h1>

                <h3>{i18n.TITLE1}</h3>
                <p>{i18n.TEXT1_1}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_2)}</p>
                <p>{i18n.TEXT1_3}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_4)}</p>
                <p>{i18n.TEXT1_5}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_6)}</p>
                <p>{i18n.TEXT1_7}</p>
                <p>{i18n.TEXT1_8}</p>
                <p>{i18n.TEXT1_9}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT1_10)}</p>
                <p>{i18n.TEXT1_11}</p>
                <p>{i18n.TEXT1_12}</p>

                <h3>{i18n.TITLE2}</h3>
                <p>{i18n.TEXT2_1}</p>
                <p>{i18n.TEXT2_2}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_3)}</p>
                <p>{i18n.TEXT2_4}</p>
                <ul>
                    <li>{i18n.TEXT2_5}</li>
                    <li>{i18n.TEXT2_6}</li>
                </ul>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_7)}</p>
                <p>{i18n.TEXT2_8}</p>
                <p>{i18n.TEXT2_9}</p>
                <p>{i18n.TEXT2_10}</p>
                <ul>
                    <li>{i18n.TEXT2_11}</li>
                    <li>{i18n.TEXT2_12}</li>
                </ul>
                <p>{i18n.TEXT2_13}</p>
                <p>{i18n.TEXT2_14}</p>
                <p>{i18n.TEXT2_15}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_16)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_17)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_18)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_19)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_20)}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT2_21)}</p>

                <h3>{i18n.TITLE3}</h3>
                <p>{i18n.TEXT3_1}</p>
                <p>{i18n.TEXT3_2}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_3)}</p>
                <p>{i18n.TEXT3_4}</p>
                <ul>
                    <li>{i18n.TEXT3_5}</li>
                    <li>{i18n.TEXT3_6}</li>
                </ul>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_7)}</p>
                <p>{i18n.TEXT3_8}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_9)}</p>
                <p>{i18n.TEXT3_10}</p>
                <p>{i18n.TEXT3_11}</p>
                <p>{i18n.TEXT3_12}</p>
                <p>{convertHtmlToReactDomWithParams(i18n.TEXT3_13)}</p>
                <p>{i18n.TEXT3_14}</p>
                <p>{i18n.TEXT3_15}</p>
                <p>{i18n.TEXT3_16}</p>
                <p>{i18n.TEXT3_17}</p>
                <p>{i18n.TEXT3_18}</p>
                <p>{i18n.TEXT3_19}</p>
                <p>{i18n.TEXT3_20}</p>
            </main>
        );
    }
}

LegalNoticePage.propTypes = {
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.LEGAL_NOTICE
    };
}

export default withTemplate(connect(mapStateToProps)(LegalNoticePage), PrimaryTemplate);



// WEBPACK FOOTER //
// ./src/components/pages/LegalNoticePage.js